/**
 * YOUP Get Your Pillow Code - JavaScript
 * Multi-step wizard with pillow code calculation
 */
scanUrl = '';
(function(){
  console.log("loaded");
  // Hide all sibling elements after main section for clean funnel experience
  document.addEventListener('DOMContentLoaded', function(){
    const main = document.querySelector('main#main, main');
    if(main){
      // Hide all siblings after main
      let sibling = main.nextElementSibling;
      while(sibling){
        sibling.style.display = 'none';
        sibling = sibling.nextElementSibling;
      }
    }
    
    // Hide any sections after our funnel section within main
    const gypSection = document.getElementById('gypc');
    if(gypSection && gypSection.parentElement){
      let sibling = gypSection.parentElement.nextElementSibling;
      while(sibling){
        sibling.style.display = 'none';
        sibling = sibling.nextElementSibling;
      }
    }
    
    // Also hide footer if it exists
    const footer = document.querySelector('footer, [role="contentinfo"]');
    if(footer) footer.style.display = 'none';
  });
  
  const $ = (s,ctx=document)=>ctx.querySelector(s);
  const $$ = (s,ctx=document)=>Array.from(ctx.querySelectorAll(s));
  const toast=(m)=>{const t=$("#g-toast");t.textContent=m;t.classList.add("on");setTimeout(()=>t.classList.remove("on"),1800);};
  const IN2CM=2.54;

  // URL params - Parse first to get unit preference
  const p=new URLSearchParams(location.search);
  const normSP=v=>!v?"":(/side/i.test(v)?"Side":/back/i.test(v)?"Back":/(stomach|belly|front)/i.test(v)?"Stomach":"");
  const normMAT=v=>!v?"":(/soft|plush/i.test(v)?"Soft":/firm|hard/i.test(v)?"Firm":/med|medium/i.test(v)?"Medium":"");
  const spQ=normSP(p.get("sp")), matQ=normMAT(p.get("mat"));
  const emailQ=p.get("email")?decodeURIComponent(p.get("email")):"";
  const orderQ=p.get("order_name")||p.get("order")||"";
  const nameQ=p.get("name")?decodeURIComponent(p.get("name")):"";
  
  // New URL parameters: unit and height
  const unitParam = p.get("unit") || "in";
  const heightParam = p.get("height") || "";
  
  // State
  let currentStep = 'landing';
  let currentUnit = unitParam.toLowerCase() === 'cm' ? 'cm' : 'in';
  let formData = {
    shoulders: '',
    neck: '',
    necklen: ''
  };
  
  // Refs
  const order=$("#g-order"), email=$("#g-email"), sp=$("#g-sp"), mat=$("#g-mat");
  
  // Safely set values only if elements exist
  if(!order || !email || !sp || !mat){
    console.error('Required form elements not found');
    return;
  }

  // Prefill
  if(orderQ && order) order.value=orderQ;
  if(emailQ && email) email.value=emailQ;
  if(spQ && sp) sp.value=spQ;
  if(matQ && mat) mat.value=matQ;

  // Parse height based on unit parameter
  function parseHeightToCm(heightValue, unit){
    if(!heightValue) return 0;
    const numValue = parseFloat(heightValue);
    if(isNaN(numValue)) return 0;
    
    if(unit === 'cm'){
      return Math.round(numValue);
    } else {
      // const match = heightValue.match(/(\d+)\s*(?:ft|['′])\s*(\d+)?\s*(?:in|["″])?/i);
      // if (!match) return null;

      // const feet = parseInt(match[1], 10);
      // const inches = parseInt(match[2] || 0, 10);

      // return parseInt(feet * 30.48 + inches * 2.54);
      return Math.round(numValue * IN2CM);
    }
  }
  
  // Format height display based on current unit
  function formatHeight(cm){
    if(!cm || cm === 0) return '—';
    if(currentUnit === 'cm'){
      return `${cm} cm`;
    } else {
      const totalInches = Math.round(cm / IN2CM);
      return `${totalInches} in`;
    }
  }
  
  // Edit Details landing: Always shows first, pre-filled with URL params or defaults
  let editData = {
    name: nameQ || (emailQ ? emailQ.split('@')[0] : 'John'),
    email: emailQ || '',
    order: orderQ || '',
    sp: spQ || '',
    mat: matQ || '',
    heightCm: parseHeightToCm(heightParam, currentUnit),
    isEditMode: false
  };
  
  // Validation ranges (in cm)
  const RANGES = {
    shoulders: { min: 27, max: 64, minInch: 10.5, maxInch: 25.5, label: 'Shoulder width' },
    neck: { min: 25, max: 49, minInch: 10, maxInch: 19, label: 'Neck circumference' },
    head: { min: 40, max: 79, minInch: 15.5, maxInch: 31, label: 'Head circumference' },
    necklen: { min: 8, max: 27, minInch: 3, maxInch: 10.5, label: 'Neck length' },
    height: { min: 140, max: 220, label: 'Height' }
  };
  
  // Validate that a value is selected (no range validation needed for dropdowns)
  function validateSelection(value, field) {
    const range = RANGES[field];
    if (!value || value === '') {
      return { 
        valid: false, 
        message: `Please select a value for ${range ? range.label.toLowerCase() : 'this field'}`
      };
    }
    return { valid: true };
  }
  
  // Populate dropdown with values based on range and unit
  function populateDropdown(selectId, field, unit, selectedValue = null) {
    const select = $(selectId);
    if (!select) return;
    
    const range = RANGES[field];
    if (!range) return;
    
    // Use specific inch/cm ranges
    let minValue, maxValue;
    if (unit === 'in') {
      minValue = range.minInch || (range.min / IN2CM);
      maxValue = range.maxInch || (range.max / IN2CM);
    } else {
      minValue = range.min;
      maxValue = range.max;
    }
    
    // Determine increment (0.5 for inches, 1 for cm)
    const increment = unit === 'in' ? 0.5 : 1;
    
    // Clear existing options except first
    select.innerHTML = '<option value="">...</option>';
    
    // Track closest match for selectedValue
    let closestOption = null;
    let closestDiff = Infinity;
    
    // Generate options
    for (let val = minValue; val <= maxValue; val += increment) {
      const option = document.createElement('option');
      const displayValue = val.toFixed(1);
      option.value = displayValue;
      option.textContent = displayValue;
      
      // Find closest match to selectedValue
      if (selectedValue !== null && selectedValue !== undefined) {
        const diff = Math.abs(parseFloat(displayValue) - selectedValue);
        if (diff < closestDiff) {
          closestDiff = diff;
          closestOption = option;
        }
      }
      
      select.appendChild(option);
    }
    
    // Select the closest option if we have a selectedValue
    if (closestOption) {
      closestOption.selected = true;
    }
  }
  
  // Initialize all dropdowns with inch values
  function initializeDropdowns() {
    populateDropdown('#inp-shoulders', 'shoulders', currentUnit);
    populateDropdown('#inp-neck', 'neck', currentUnit);
    populateDropdown('#inp-head', 'head', currentUnit);
    populateDropdown('#inp-necklen', 'necklen', currentUnit);
  }
  
  // Show validation error
  function showError(inputId, message, stepNumber) {
    const input = $(inputId);
    if (input) {
      input.style.borderColor = '#ff0000';
      setTimeout(() => input.style.borderColor = '', 3000);
    }
    
    // Show error message for mobile
    const errorMessage = $(`#error-step-${stepNumber}`);
    
    if (errorMessage) {
      errorMessage.style.display = 'flex';
    }
    
    // Add error class to the visual card for this step
    const visualCard = $(`#step-${stepNumber} .visual-card`);
    if (visualCard) {
      visualCard.classList.add('error');
    }
  }
  
  // Hide validation error
  function hideError(stepNumber) {
    const errorMessage = $(`#error-step-${stepNumber}`);
    const visualCard = $(`#step-${stepNumber} .visual-card`);
    
    if (errorMessage) {
      errorMessage.style.display = 'none';
    }
    
    if (visualCard) {
      visualCard.classList.remove('error');
    }
  }

  // Add change event listeners to hide errors when user selects a value
  const shouldersSelect = $("#inp-shoulders");
  const neckSelect = $("#inp-neck");
  const headSelect = $("#inp-head");
  const necklenSelect = $("#inp-necklen");
  
  if (shouldersSelect) shouldersSelect.addEventListener("change", () => hideError(1));
  if (neckSelect) neckSelect.addEventListener("change", () => hideError(2));
  if (headSelect) headSelect.addEventListener("change", () => hideError(3));
  if (necklenSelect) necklenSelect.addEventListener("change", () => hideError(4));
  
  // YOUP Pillow Code Lookup Table (from official spec)
  const PILLOW_TABLE = [
    { id: 1,  pillowNr: 6,  type: '08510', fFrom: 10, fTill: 20, nFrom: 1,  nTill: 16 },
    { id: 2,  pillowNr: 7,  type: '08512', fFrom: 10, fTill: 20, nFrom: 16, nTill: 85 },
    { id: 3,  pillowNr: 8,  type: '09510', fFrom: 20, fTill: 25, nFrom: 1,  nTill: 18 },
    { id: 4,  pillowNr: 9,  type: '09512', fFrom: 20, fTill: 25, nFrom: 18, nTill: 85 },
    { id: 5,  pillowNr: 10, type: '10510', fFrom: 25, fTill: 28, nFrom: 1,  nTill: 21 },
    { id: 6,  pillowNr: 11, type: '10512', fFrom: 25, fTill: 28, nFrom: 21, nTill: 85 },
    { id: 7,  pillowNr: 14, type: '11510', fFrom: 28, fTill: 39, nFrom: 1,  nTill: 22 },
    { id: 8,  pillowNr: 15, type: '11512', fFrom: 29, fTill: 39, nFrom: 22, nTill: 85 },
    { id: 9,  pillowNr: 17, type: '12510', fFrom: 39, fTill: 46, nFrom: 1,  nTill: 22 },
    { id: 10, pillowNr: 18, type: '12512', fFrom: 39, fTill: 46, nFrom: 22, nTill: 85 },
    { id: 11, pillowNr: 19, type: '13510', fFrom: 46, fTill: 52, nFrom: 1,  nTill: 21 },
    { id: 12, pillowNr: 20, type: '13512', fFrom: 46, fTill: 52, nFrom: 21, nTill: 85 },
    { id: 13, pillowNr: 21, type: '14510', fFrom: 52, fTill: 99, nFrom: 1,  nTill: 21 },
    { id: 14, pillowNr: 22, type: '14512', fFrom: 52, fTill: 99, nFrom: 21, nTill: 85 }
  ];
  
  // Calculate pillow code using official YOUP formula
  function calculatePillowCode(shoulderCm, neckCircCm, sleepPosition, mattressType) {
    // Sleep multipliers
    const Z = {
      'Side': 1.0,
      'Back': 0.8,
      'Stomach': 0.7
    }[sleepPosition] || 1.0;
    
    // Mattress multipliers
    const M = {
      'Firm': 1.05,
      'Medium': 1.0,
      'Soft': 0.9
    }[mattressType] || 1.0;
    
    // Core formula
    const base = (shoulderCm * 1.5) - (neckCircCm * 0.6896);
    const height = base * Z * M;
    const heightCm = Math.round(height);
    
    // Lookup in table
    const neckRounded = Math.round(neckCircCm);
    
    // Find exact match
    let match = PILLOW_TABLE.find(row => 
      heightCm >= row.fFrom && heightCm <= row.fTill &&
      neckRounded >= row.nFrom && neckRounded <= row.nTill
    );
    
    // Fallback: find closest match
    if (!match) {
      let bestRow = PILLOW_TABLE[0];
      let bestScore = Infinity;
      
      for (const row of PILLOW_TABLE) {
        const heightMid = (row.fFrom + row.fTill) / 2;
        const heightDist = Math.abs(heightCm - heightMid);
        
        let neckDist = 0;
        if (neckRounded < row.nFrom) {
          neckDist = row.nFrom - neckRounded;
        } else if (neckRounded > row.nTill) {
          neckDist = neckRounded - row.nTill;
        }
        
        const score = heightDist * 10 + neckDist;
        if (score < bestScore) {
          bestScore = score;
          bestRow = row;
        }
      }
      match = bestRow;
    }
    
    return {
      code: 'YP' + match.type,
      pillowNr: match.pillowNr,
      heightCm: heightCm
    };
  }

  //get order detail to check order status
  document.addEventListener('DOMContentLoaded', async () => {
    try {
      // --- Step 1: Extract order name from query string ---
      const params = new URLSearchParams(window.location.search);
      let orderName = params.get('order_name'); // e.g. ?order_name=251044

      if (orderName === null ||  orderName == "") {
        editData.name = params.get('email').split("@")[0] ?? '';
      } else {
        orderName = orderName.replace('#', '').trim();
        //console.log('Looking up order:', orderName);

        // --- Step 2: Fetch from your Laravel API ---
        const apiUrl = `https://api.youpsleep.com/api/order/lookup/name/${orderName}`;
        const response = await fetch(apiUrl, { headers: { 'Accept': 'application/json' } });

        if (!response.ok) {
          console.error('Failed to fetch order data:', response.status);
          return;
        }

        const order = await response.json();
        editData.name = order.customer ? order.customer.firstName : 'John';
        //console.log('Order data:', order);

        const tags = Array.isArray(order.tags)
          ? order.tags
          : (typeof order.tags === 'string'
              ? order.tags.split(',').map(t => t.trim())
              : []);

        if (tags.includes('Order Complete') || order.cancelled) {
          showOrderCompletePopup();
        }
      }

      // Initialize Edit Details landing - always shows first
      const greet = $("#edit-greeting");
      const compactTitle = $("#profile-compact-title");
      const mobileCompactTitle = $("#mobile-profile-compact-title");
      if(greet) greet.textContent = `${editData.name.charAt(0).toUpperCase() + editData.name.slice(1)}, let's finish customizing your pillow`;
      if(compactTitle) compactTitle.textContent = `${editData.name.charAt(0).toUpperCase() + editData.name.slice(1)}, let's finish customizing your pillow`;
      if(mobileCompactTitle) mobileCompactTitle.textContent = `${editData.name.charAt(0).toUpperCase() + editData.name.slice(1)}, let's finish customizing your pillow`;

      } catch (error) {
        console.error('Error checking order status:', error);
      }
    }
  );
    
  const editCode = $("#edit-code");
  if(editCode) editCode.textContent = 'Complete measurements to generate code';
  
  const editSpDisplay = $("#edit-sp-display");
  const editSpSelect = $("#edit-sp");
  if(editSpDisplay) editSpDisplay.textContent = editData.sp || '—';
  if(editSpSelect) editSpSelect.value = editData.sp;
  
  const editMatDisplay = $("#edit-mat-display");
  const editMatSelect = $("#edit-mat");
  if(editMatDisplay) editMatDisplay.textContent = editData.mat || '—';
  if(editMatSelect) editMatSelect.value = editData.mat;
  
  const editHeightDisplay = $("#edit-height-display");
  if(editHeightDisplay) editHeightDisplay.textContent = formatHeight(editData.heightCm);
  
  const editOrderDisplay = $("#edit-order-display");
  if(editOrderDisplay) editOrderDisplay.textContent = editData.order || '#000000';
  
  // Update mobile fields
  const mobileSp = $("#mobile-sp");
  if(mobileSp) mobileSp.textContent = editData.sp;
  
  const mobileMat = $("#mobile-mat");
  if(mobileMat) mobileMat.textContent = editData.mat;
  
  const mobileHeight = $("#mobile-height");
  if(mobileHeight) mobileHeight.textContent = formatHeight(editData.heightCm);
  
  const mobileOrder = $("#mobile-order");
  if(mobileOrder) mobileOrder.textContent = editData.order || '#000000';
  
  // Update mobile expanded fields
  const mobileSpExpanded = $("#mobile-sp-expanded");
  if(mobileSpExpanded) mobileSpExpanded.textContent = editData.sp;
  
  const mobileMatExpanded = $("#mobile-mat-expanded");
  if(mobileMatExpanded) mobileMatExpanded.textContent = editData.mat;
  
  const mobileHeightExpanded = $("#mobile-height-expanded");
  if(mobileHeightExpanded) mobileHeightExpanded.textContent = formatHeight(editData.heightCm);
  
  const mobileOrderExpanded = $("#mobile-order-expanded");
  if(mobileOrderExpanded) mobileOrderExpanded.textContent = editData.order || '#000000';
  
  // Update compact view
  const compactSp = $("#compact-sp");
  const compactMat = $("#compact-mat");
  const compactHeight = $("#compact-height");
  const compactOrder = $("#compact-order");
  if(compactSp) compactSp.textContent = editData.sp || '—';
  if(compactMat) compactMat.textContent = editData.mat || '—';
  if(compactHeight) compactHeight.textContent = formatHeight(editData.heightCm);
  if(compactOrder) compactOrder.textContent = editData.order || '#000000';
  
  // Show Edit Details landing as first screen
  currentStep = 'edit-landing';
  showStep('edit-landing');
  
  // Toggle between collapsed and expanded views
  const btnEditDetails = $("#btn-edit-details");
  const btnEditDetailsMobile = $("#btn-edit-details-mobile");
  
  const handleEditDetailsClick = () => {
    // Handle desktop collapsed/expanded
    const collapsed = $("#profile-collapsed");
    const expanded = $("#profile-expanded");
    const measurementOptions = $("#measurement-options");
    if(collapsed) collapsed.style.display = "none";
    if(expanded) expanded.style.display = "block";
    if(measurementOptions) measurementOptions.classList.add('blurred');
    
    // Handle mobile collapsed/expanded
    const mobileCollapsed = $("#mobile-profile-collapsed");
    const mobileExpanded = $("#mobile-profile-expanded");
    if(mobileCollapsed) mobileCollapsed.style.display = "none";
    if(mobileExpanded) mobileExpanded.style.display = "block";
  };
  
  if(btnEditDetails){
    btnEditDetails.addEventListener("click", handleEditDetailsClick);
  }
  
  if(btnEditDetailsMobile){
    btnEditDetailsMobile.addEventListener("click", handleEditDetailsClick);
  }
  
  // Check if we have real query parameters (not just defaults)
  const hasRealQueryParams = p.toString().length > 0;
  
  // Hide Order ID field if no query params
  const orderField = document.querySelector('.field-item.muted');
  const compactOrderField = document.querySelector('.compact-field.muted');
  if (orderField) {
    orderField.style.display = hasRealQueryParams ? 'flex' : 'none';
  }
  if (compactOrderField) {
    compactOrderField.style.display = hasRealQueryParams ? 'flex' : 'none';
  }
  
  // If no query params, auto-click edit details button
  if (!hasRealQueryParams) {
    setTimeout(() => {
      handleEditDetailsClick();
    }, 100);
  }
  
  // Collapse back from expanded view (Edit button in expanded view)
  const btnCollapseView = $("#btn-collapse-view");
  const btnCollapseViewMobile = $("#btn-collapse-view-mobile");
  
  const handleCollapseView = () => {
    // Handle desktop collapse
    const collapsed = $("#profile-collapsed");
    const expanded = $("#profile-expanded");
    const measurementOptions = $("#measurement-options");
    if(collapsed) collapsed.style.display = "block";
    if(expanded) expanded.style.display = "none";
    if(measurementOptions) measurementOptions.classList.remove('blurred');
    
    // Handle mobile collapse
    const mobileCollapsed = $("#mobile-profile-collapsed");
    const mobileExpanded = $("#mobile-profile-expanded");
    if(mobileCollapsed) mobileCollapsed.style.display = "block";
    if(mobileExpanded) mobileExpanded.style.display = "none";
  };
  
  if(btnCollapseView){
    btnCollapseView.addEventListener("click", handleCollapseView);
  }
  
  if(btnCollapseViewMobile){
    btnCollapseViewMobile.addEventListener("click", handleCollapseView);
  }
  
  // Edit field changes
  const editSp = $("#edit-sp");
  if(editSp){
    editSp.addEventListener("change",(e)=>{
      editData.sp = e.target.value;
      const editSpDisplay = $("#edit-sp-display");
      if(editSpDisplay) editSpDisplay.textContent = editData.sp;
      const mobileSp = $("#mobile-sp");
      if(mobileSp) mobileSp.textContent = editData.sp;
      const mobileSpExpanded = $("#mobile-sp-expanded");
      if(mobileSpExpanded) mobileSpExpanded.textContent = editData.sp;
    });
  }
  
  const editMat = $("#edit-mat");
  if(editMat){
    editMat.addEventListener("change",(e)=>{
      editData.mat = e.target.value;
      const editMatDisplay = $("#edit-mat-display");
      if(editMatDisplay) editMatDisplay.textContent = editData.mat;
      const mobileMat = $("#mobile-mat");
      if(mobileMat) mobileMat.textContent = editData.mat;
      const mobileMatExpanded = $("#mobile-mat-expanded");
      if(mobileMatExpanded) mobileMatExpanded.textContent = editData.mat;
    });
  }
  
  const heightMinus = $("#height-minus");
  if(heightMinus){
    heightMinus.addEventListener("click",()=>{
      const increment = currentUnit === 'cm' ? 5 : Math.round(2 * IN2CM);
      const newHeight = editData.heightCm - increment;
      if(newHeight < RANGES.height.min){
        heightMinus.disabled = true;
        heightMinus.style.opacity = '0.3';
        toast(`Minimum height is ${formatHeight(RANGES.height.min)}`);
        return;
      }
      editData.heightCm = newHeight;
      const editHeightDisplay = $("#edit-height-display");
      if(editHeightDisplay) editHeightDisplay.textContent = formatHeight(editData.heightCm);
      const mobileHeight = $("#mobile-height");
      if(mobileHeight) mobileHeight.textContent = formatHeight(editData.heightCm);
      const mobileHeightExpanded = $("#mobile-height-expanded");
      if(mobileHeightExpanded) mobileHeightExpanded.textContent = formatHeight(editData.heightCm);
      
      const heightPlus = $("#height-plus");
      if(heightPlus){
        heightPlus.disabled = false;
        heightPlus.style.opacity = '1';
      }
    });
  }
  
  const heightPlus = $("#height-plus");
  if(heightPlus){
    heightPlus.addEventListener("click",()=>{
      const increment = currentUnit === 'cm' ? 5 : Math.round(2 * IN2CM);
      const newHeight = editData.heightCm + increment;
      if(newHeight > RANGES.height.max){
        heightPlus.disabled = true;
        heightPlus.style.opacity = '0.3';
        toast(`Maximum height is ${formatHeight(RANGES.height.max)}`);
        return;
      }
      editData.heightCm = newHeight;
      const editHeightDisplay = $("#edit-height-display");
      if(editHeightDisplay) editHeightDisplay.textContent = formatHeight(editData.heightCm);
      const mobileHeight = $("#mobile-height");
      if(mobileHeight) mobileHeight.textContent = formatHeight(editData.heightCm);
      const mobileHeightExpanded = $("#mobile-height-expanded");
      if(mobileHeightExpanded) mobileHeightExpanded.textContent = formatHeight(editData.heightCm);
      
      const heightMinus = $("#height-minus");
      if(heightMinus){
        heightMinus.disabled = false;
        heightMinus.style.opacity = '1';
      }
    });
  }
  
  // Save edited profile
  const btnSaveProfile = $("#btn-save-profile");
  if(btnSaveProfile){
    btnSaveProfile.addEventListener("click",()=>{
      // Update compact view
      const compactSp = $("#compact-sp");
      const compactMat = $("#compact-mat");
      const compactHeight = $("#compact-height");
      if(compactSp) compactSp.textContent = editData.sp;
      if(compactMat) compactMat.textContent = editData.mat;
      if(compactHeight) compactHeight.textContent = formatHeight(editData.heightCm);
      
      // Update mobile fields
      const mobileSp = $("#mobile-sp");
      const mobileMat = $("#mobile-mat");
      const mobileHeight = $("#mobile-height");
      if(mobileSp) mobileSp.textContent = editData.sp;
      if(mobileMat) mobileMat.textContent = editData.mat;
      if(mobileHeight) mobileHeight.textContent = formatHeight(editData.heightCm);
      
      // Update mobile expanded fields
      const mobileSpExpanded = $("#mobile-sp-expanded");
      const mobileMatExpanded = $("#mobile-mat-expanded");
      const mobileHeightExpanded = $("#mobile-height-expanded");
      if(mobileSpExpanded) mobileSpExpanded.textContent = editData.sp;
      if(mobileMatExpanded) mobileMatExpanded.textContent = editData.mat;
      if(mobileHeightExpanded) mobileHeightExpanded.textContent = formatHeight(editData.heightCm);
      
      const newUrl = new URL(window.location);
      newUrl.searchParams.set('sp', editData.sp);
      newUrl.searchParams.set('mat', editData.mat);
      newUrl.searchParams.set('unit', currentUnit);
      const heightValue = currentUnit === 'cm' ? editData.heightCm : Math.round(editData.heightCm / IN2CM);
      newUrl.searchParams.set('height', heightValue);
      window.history.replaceState({}, '', newUrl);

      const scanParamsObject = {
        position: (editData.sp || '').toLowerCase(),
        mattress: (editData.mat || '').toLowerCase(),
        unit: 'cm',
        height: editData.heightCm || 0
      };

      generateScanURL(editData.order, scanParamsObject);
      
      sp.value = editData.sp;
      mat.value = editData.mat;
      
      const collapsed = $("#profile-collapsed");
      const expanded = $("#profile-expanded");
      const measurementOptions = $("#measurement-options");
      if(collapsed) collapsed.style.display = "block";
      if(expanded) expanded.style.display = "none";
      if(measurementOptions) measurementOptions.classList.remove('blurred');
      
      toast("Profile updated!");
    });
  }
  
  // Navigation from Edit Details landing
  $("#btn-manual-start").addEventListener("click",()=>{
    // Validate required fields before proceeding
    if(!editData.sp || editData.sp === ''){
      toast("Please select your sleep position");
      handleEditDetailsClick();
      return;
    }
    if(!editData.mat || editData.mat === ''){
      toast("Please select your mattress type");
      handleEditDetailsClick();
      return;
    }
    if(!editData.heightCm || editData.heightCm === 0){
      toast("Please set your height");
      handleEditDetailsClick();
      return;
    }
    
    // Transfer edit data to form
    sp.value = editData.sp;
    mat.value = editData.mat;
    order.value = editData.order;
    email.value = editData.email;
    showStep('landing'); // Go to original landing page (screen 2)
  });
  
  const paramsObject = {
    position: (editData.sp || '').toLowerCase(),
    mattress: (editData.mat || '').toLowerCase(),
    unit: 'cm',
    height: editData.heightCm || 0
  };

  generateScanURL(editData.order, paramsObject);

  // Lock mechanism
  let locked=!!(orderQ||spQ||matQ);
  function applyLock(){
    sp.disabled=locked; mat.disabled=locked; order.readOnly=locked&&!!orderQ;
    $("#g-badge").textContent=locked?"From your order":"Editing";
    $("#g-unlock").textContent=locked?"Unlock to edit":"Lock (use order values)";
  }
  $("#g-unlock").addEventListener("click",()=>{locked=!locked;applyLock();});
  applyLock();

  // Navigation
  function showStep(step){
    $$('.step').forEach(s=>s.style.display='none');
    const stepEl = $(`#step-${step}`);
    if(stepEl) stepEl.style.display='block';
    currentStep = step;
    window.scrollTo(0,0);
    
    // Show preferences sidebar for measurement steps 1-4
    const prefSidebar = $("#preferences-sidebar");
    if(prefSidebar){
      if(['1','2','3','4'].includes(step)){
        prefSidebar.style.display='block';
      } else {
        prefSidebar.style.display='none';
      }
    }
  }
  
  // Start
  $$("#btn-start, #btn-start-mobile").forEach(btn => {
    btn.addEventListener("click",()=>showStep('1'));
  });
  
  const toCm=(v,u)=>{const n=Number(String(v).replace(',','.')); if(!Number.isFinite(n)||n<=0) return null; return u==="in"?n*IN2CM:n;};
  const fromCm=(v,u)=>{if(!v) return ''; return u==="in"?(v/IN2CM).toFixed(1):v.toFixed(1);};
  
  function updateUnitLabels(){
    const label = currentUnit === 'cm' ? 'cm' : 'inches';
    $$('.unit-label').forEach(el=>el.textContent=label);
    $$('.btn.ghost-small').forEach(el=>{
      el.style.display = 'none';
    });
  }
  
  // Step 1 navigation
  $("#back-1").addEventListener("click",()=>showStep('landing'));
  $("#continue-1").addEventListener("click",()=>{
    const val = $("#inp-shoulders").value;
    const validation = validateSelection(val, 'shoulders');
    if (!validation.valid) {
      showError("#inp-shoulders", validation.message, 1);
      return;
    }
    hideError(1);
    const valueCm = toCm(val, currentUnit);
    formData.shoulders = valueCm;
    showStep('2');
  });
  
  // Step 2 navigation
  $("#back-2").addEventListener("click",()=>{
    const val = $("#inp-neck").value;
    if(val) formData.neck = toCm(val, currentUnit);
    hideError(2);
    showStep('1');
  });
  $("#continue-2").addEventListener("click",()=>{
    const val = $("#inp-neck").value;
    const validation = validateSelection(val, 'neck');
    if (!validation.valid) {
      showError("#inp-neck", validation.message, 2);
      return;
    }
    hideError(2);
    const valueCm = toCm(val, currentUnit);
    formData.neck = valueCm;
    showStep('3');
  });
  
  // Step 3 navigation
  $("#back-3").addEventListener("click",()=>{
    const val = $("#inp-head").value;
    if(val) formData.head = toCm(val, currentUnit);
    hideError(3);
    showStep('2');
  });
  $("#continue-3").addEventListener("click",()=>{
    const val = $("#inp-head").value;
    const validation = validateSelection(val, 'head');
    if (!validation.valid) {
      showError("#inp-head", validation.message, 3);
      return;
    }
    hideError(3);
    const valueCm = toCm(val, currentUnit);
    formData.head = valueCm;
    showStep('4');
  });
  
  // Step 4 navigation
  $("#back-4").addEventListener("click",()=>{
    const val = $("#inp-necklen").value;
    if(val) formData.necklen = toCm(val, currentUnit);
    hideError(4);
    showStep('3');
  });
  $("#continue-4").addEventListener("click",()=>{
    const val = $("#inp-necklen").value;
    const validation = validateSelection(val, 'necklen');
    if (!validation.valid) {
      showError("#inp-necklen", validation.message, 4);
      return;
    }
    hideError(4);
    const valueCm = toCm(val, currentUnit);
    formData.necklen = valueCm;
    showReview();
    showStep('review');
  });
  
  function showReview(){
    const result = calculatePillowCode(
      formData.shoulders,
      formData.neck,
      sp.value,
      mat.value
    );
    
    formData.finalCode = result.code;
    formData.pillowNr = result.pillowNr;
    
    $("#review-code").textContent = result.code;
    $("#review-sp").textContent = sp.value || "—";
    $("#review-mat").textContent = mat.value || "—";
    $("#review-height").textContent = formatHeight(editData.heightCm);
    $("#review-shoulders").textContent = `${fromCm(formData.shoulders, currentUnit)} ${currentUnit}`;
    $("#review-neck").textContent = `${fromCm(formData.neck, currentUnit)} ${currentUnit}`;
    $("#review-head").textContent = `${fromCm(formData.head, currentUnit)} ${currentUnit}`;
    $("#review-necklen").textContent = `${fromCm(formData.necklen, currentUnit)} ${currentUnit}`;
    $("#review-order").textContent = order.value || "—";
  }
  
  // Edit button - Toggle between collapsed and expanded review views
  const btnEdit = $("#btn-edit");
  const btnReviewCollapse = $("#btn-review-collapse");
  
  // Edit measurements button - Go back to step 1
  const btnEditMeasurements = $("#btn-edit-measurements");
  
  const handleReviewEditClick = () => {
    // Handle desktop collapsed/expanded
    const collapsed = $("#review-collapsed");
    const expanded = $("#review-expanded");
    if(collapsed) collapsed.style.display = "none";
    if(expanded) expanded.style.display = "block";
    
    // Set dropdown values to current values (display spans are hidden by CSS)
    const reviewSpSelect = $("#review-edit-sp");
    const reviewMatSelect = $("#review-edit-mat");
    
    if(reviewSpSelect) {
      reviewSpSelect.value = sp.value || "Side";
    }
    if(reviewMatSelect) {
      reviewMatSelect.value = mat.value || "Medium";
    }
    
    // Copy all other values to edit view
    const reviewEditCode = $("#review-edit-code");
    const reviewEditHeight = $("#review-edit-height");
    const reviewEditShoulders = $("#review-edit-shoulders");
    const reviewEditNeck = $("#review-edit-neck");
    const reviewEditHead = $("#review-edit-head");
    const reviewEditNecklen = $("#review-edit-necklen");
    const reviewEditOrder = $("#review-edit-order");
    
    if(reviewEditCode) reviewEditCode.textContent = $("#review-code").textContent;
    if(reviewEditHeight) reviewEditHeight.textContent = $("#review-height").textContent;
    if(reviewEditShoulders) reviewEditShoulders.textContent = $("#review-shoulders").textContent;
    if(reviewEditNeck) reviewEditNeck.textContent = $("#review-neck").textContent;
    if(reviewEditHead) reviewEditHead.textContent = $("#review-head").textContent;
    if(reviewEditNecklen) reviewEditNecklen.textContent = $("#review-necklen").textContent;
    if(reviewEditOrder) reviewEditOrder.textContent = $("#review-order").textContent;
  };
  
  const handleReviewCollapseClick = () => {
    // Handle desktop collapse
    const collapsed = $("#review-collapsed");
    const expanded = $("#review-expanded");
    if(collapsed) collapsed.style.display = "block";
    if(expanded) expanded.style.display = "none";
  };
  
  if(btnEdit){
    btnEdit.addEventListener("click", handleReviewEditClick);
  }
  
  if(btnReviewCollapse){
    btnReviewCollapse.addEventListener("click", handleReviewCollapseClick);
  }
  
  // Edit measurements button - Go back to step 1
  if(btnEditMeasurements){
    btnEditMeasurements.addEventListener("click", () => {
      showStep('1');
    });
  }
  
  // Review edit field changes - no need to update display spans since they're hidden
  
  // Save review changes
  const btnReviewSave = $("#btn-review-save");
  if(btnReviewSave){
    btnReviewSave.addEventListener("click",()=>{
      // Get new values from edit fields
      const newSp = $("#review-edit-sp").value;
      const newMat = $("#review-edit-mat").value;
      
      // Update form values
      sp.value = newSp;
      mat.value = newMat;
      
      // Recalculate pillow code with new values
      const result = calculatePillowCode(
        formData.shoulders,
        formData.neck,
        newSp,
        newMat
      );
      
      // Store for success page
      formData.finalCode = result.code;
      formData.pillowNr = result.pillowNr;
      
      $("#review-code").textContent = result.code;
      $("#review-sp").textContent = newSp;
      $("#review-mat").textContent = newMat;
      
      const newUrl = new URL(window.location);
      newUrl.searchParams.set('sp', newSp);
      newUrl.searchParams.set('mat', newMat);
      newUrl.searchParams.set('unit', currentUnit);
      const heightValue = currentUnit === 'cm' ? editData.heightCm : Math.round(editData.heightCm / IN2CM);
      newUrl.searchParams.set('height', heightValue);
      window.history.replaceState({}, '', newUrl);
      
      handleReviewCollapseClick();
      
      toast("Preferences updated!");
    });
  }
  
  // Confirm & Save
  $("#btn-confirm").addEventListener("click", async ()=>{
    const code = $("#review-code").textContent;
    const orderNumber = $("#review-order").textContent;
    
    // Validate order number
    if (!orderNumber || orderNumber === "—" || orderNumber === "") {
      toast("Order number is required");
      return;
    }
    
    // Remove # if present
    const cleanOrderNumber = orderNumber.replace(/^#/, '');
    
    // Show loading state
    const confirmBtn = $("#btn-confirm");
    const originalBtnText = confirmBtn.innerHTML;
    confirmBtn.disabled = true;
    confirmBtn.innerHTML = '<span class="loading-dots"><span>.</span><span>.</span><span>.</span><span>.</span></span>';
    
    try {
      // Step 1: Get token from order lookup
      const lookupResponse = await fetch(`https://api.youpsleep.com/api/order/lookup/name/${cleanOrderNumber}`, {
        method: 'GET',
        headers: {
          'X-Shopify-Youpsleep': 'Y'
        }
      });
      
      if (!lookupResponse.ok) {
        throw new Error('Order lookup failed');
      }
      
      const lookupData = await lookupResponse.json();
      const token = lookupData.token;
      
      if (!token) {
        throw new Error('No token received from order lookup');
      }
      
      // Step 2: Convert measurements to mm (formData stores values in cm)
      const shoulderDistanceMm = Math.round(formData.shoulders * 10);
      const neckCircMm = Math.round(formData.neck * 10);
      const headCircMm = Math.round(formData.head * 10);
      const neckLengthMm = Math.round(formData.necklen * 10);
      
      // Step 3: Submit scan complete
      const scanFormData = new FormData();
      scanFormData.append('token', token);
      scanFormData.append('pillow_code', code);
      scanFormData.append('shoulder_distance_mm', shoulderDistanceMm);
      scanFormData.append('neck_circ_mm', neckCircMm);
      scanFormData.append('head_circ_mm', headCircMm);
      scanFormData.append('neck_length_mm', neckLengthMm);
      scanFormData.append('sleep_position', sp.value || 'Side');
      scanFormData.append('mattress_type', mat.value || 'Medium');
      scanFormData.append('height_cm', editData.heightCm || 180);
      
      const scanResponse = await fetch('https://api.youpsleep.com/api/scan/complete', {
        method: 'POST',
        headers: {
          'X-Shopify-Youpsleep': 'Y'
        },
        body: scanFormData
      });
      
      if (!scanResponse.ok) {
        throw new Error('Scan complete submission failed');
      }
      
      // Success - store data locally as backup
      try {
        const measurementData = {
          code: code,
          order: orderNumber,
          email: email.value || "",
          sleepPosition: sp.value || "",
          mattressType: mat.value || "",
          heightCm: editData.heightCm,
          measurements: {
            shouldersMm: shoulderDistanceMm,
            neckMm: neckCircMm,
            headMm: headCircMm,
            neckLengthMm: neckLengthMm
          },
          timestamp: new Date().toISOString()
        };
        localStorage.setItem('youp_pillow_code', JSON.stringify(measurementData));
        console.log('Pillow code data saved:', measurementData);
      } catch(e) {
        console.error('LocalStorage error:', e);
      }
      
      // Show success page
      const name = editData.name.charAt(0).toUpperCase() + editData.name.slice(1);
      $("#customer-name").textContent = name;
      showStep('success');
      toast("Success! Thank you!");
      
    } catch(e) {
      console.error('Submission error:', e);
      toast("Error saving. Please try again or contact support.");
      
      // Restore button
      confirmBtn.disabled = false;
      confirmBtn.innerHTML = originalBtnText;
    }
  });
  
  // Initialize
  updateUnitLabels();
  initializeDropdowns();
})();

//

//generate scan url
function openScanURL() {
  window.open(scanUrl, '_blank');
}

async function generateScanURL(orderNumber, paramsObject) {
  try {
    const cleanOrderNumber = orderNumber.replace(/^#/, '');

    if (cleanOrderNumber != "") {
      const response = await fetch(`https://api.youpsleep.com/api/order/lookup/name/${cleanOrderNumber}`, {
        method: 'GET',
        headers: {
            'X-Shopify-Youpsleep': true  
          }
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();

      if (data.token) {
        paramsObject.token = data.token;
      }
    }

    const searchParams = new URLSearchParams(paramsObject);
    const queryString = searchParams.toString();

    scanUrl = 'https://scan.youpsleep.com/?' + queryString;
    document.querySelector('.qr-img').src = "https://api.youpsleep.com/api/pillow-scan-qr?scanner_url=" + encodeURIComponent(scanUrl) + '&size=180';

    btnScanStart = document.getElementById("btn-scan-start");
    if (btnScanStart) {
        btnScanStart.removeEventListener("click", () => {
            openScanURL();
        });
        btnScanStart.addEventListener("click", () => {
            openScanURL();
        });
    }
    btnPillowScan1 = document.getElementById("btn-pillowscan");
    if (btnPillowScan1) {
        btnPillowScan1.removeEventListener("click", () => {
            openScanURL();
        });
        btnPillowScan1.addEventListener("click", () => {
            openScanURL();
        });
    }
    btnPillowScan2 = document.getElementById("btn-pillowscan-mobile");
    if (btnPillowScan2) {
        btnPillowScan2.removeEventListener("click", () => {
            openScanURL();
        });
        btnPillowScan2.addEventListener("click", () => {
            openScanURL();
        });
    }

    return null;

  } catch (error) {
    console.error("Error fetching token:", error);
    return null;
  }
}

function showOrderCompletePopup() {
  const overlay = document.createElement('div');
  overlay.id = 'order-popup-overlay';
  overlay.style = `
    position: fixed;
    top: 0; left: 0;
    width: 100vw; height: 100vh;
    background-color: rgba(0,0,0,0.5);
    z-index: 9998;
  `;

  const popup = document.createElement('div');
  popup.innerHTML = `
    <div id="order-popup" style="
      position: fixed;
      top: 50%; left: 50%;
      transform: translate(-50%, -50%);
      background: white;
      color: black;
      padding: 20px 30px;
      border-radius: 10px;
      box-shadow: 0 4px 25px rgba(0,0,0,0.4);
      z-index: 9999;
      max-width: 400px;
      text-align: center;
      font-family: sans-serif;
    ">
      <h3 style="margin-bottom: 10px;">Your Order Is Already Complete ✅</h3>
      <p>Thanks for checking! Your pillow order and measurements are already finalized — no further action needed. You can sit back and get ready for better sleep. 💤</p>
      <button id="popup-close" style="
        margin-top: 15px;
        padding: 10px 20px;
        border: none;
        background: #000;
        color: #fff;
        border-radius: 5px;
        cursor: pointer;
      ">OK</button>
    </div>
  `;
  document.body.appendChild(overlay);
  document.body.appendChild(popup);
  document.body.style.overflow = 'hidden';

  document.getElementById('popup-close').addEventListener('click', () => {
    window.location.href = '/';
  });
}